import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { adminModulesApi, ModuleListEntry } from '../api/adminModules';

// Modules that currently have a global settings page wired up. Others land on a
// "Coming soon" card. Keep this in lockstep with App.tsx route registrations.
const MODULES_WITH_SETTINGS: Record<string, string> = {
  'data-mapping': 'Manage core schemas',
};

export default function AdminModules() {
  const { getToken } = useAuth();
  const [modules, setModules] = useState<ModuleListEntry[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      try {
        const t = await getToken();
        const list = await adminModulesApi.list(t);
        setModules(list);
      } catch (e) { setError(e instanceof Error ? e.message : String(e)); }
    })();
  }, [getToken]);

  return (
    <div>
      <h1 style={{ color: 'var(--mi-navy)' }}>Modules</h1>
      <p style={{ color: 'var(--mi-muted)', marginTop: 0 }}>
        Global settings that apply across every client. Per-client configuration lives under each client&rsquo;s Settings page.
      </p>

      {error && <div style={errBox}>{error}</div>}
      {!modules && !error && <div>Loading…</div>}

      {modules && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 16 }}>
          {modules.map((m) => {
            const cta = MODULES_WITH_SETTINGS[m.code];
            return (
              <div key={m.code} className="card" style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                <div>
                  <h2 style={{ margin: 0, fontSize: 16, color: 'var(--mi-navy)' }}>{m.name}</h2>
                  {m.description && (
                    <div style={{ fontSize: 13, color: 'var(--mi-muted)', marginTop: 4 }}>{m.description}</div>
                  )}
                </div>
                <div style={{ marginTop: 'auto', paddingTop: 12, borderTop: '1px solid var(--mi-border)' }}>
                  {cta ? (
                    <Link to={`/admin/modules/${m.code}`} style={{ color: 'var(--mi-purple)', textDecoration: 'none', fontWeight: 600, fontSize: 13 }}>
                      {cta} →
                    </Link>
                  ) : (
                    <span style={{ fontSize: 12, color: 'var(--mi-muted)' }}>Coming soon</span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

const errBox: React.CSSProperties = { background: '#fee', color: '#900', padding: '8px 12px', borderRadius: 6, marginBottom: 12, fontSize: 14 };
